/**
 * Route for `hasoffers-tune-integration-via-api`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { HasoffersTuneIntegrationViaApiPage } from "../features/hasoffers-tune-integration-via-api/HasoffersTuneIntegrationViaApiPage";

export const hasoffersTuneIntegrationViaApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/hasoffers-tune-integration-via-api",
	component: HasoffersTuneIntegrationViaApiPage,
});

export default hasoffersTuneIntegrationViaApiRoute;
